// Animates <details> open/close; without JS they still toggle instantly.
const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
const DURATION = 320;

function toggle(item: HTMLDetailsElement, summary: HTMLElement): void {
	// The class leads during an animation; item.open only drops once closing ends.
	const opening = !item.classList.contains('is-open');
	const start = item.offsetHeight;

	item.getAnimations().forEach((animation) => animation.cancel());

	if (opening) {
		item.open = true;
	}

	item.classList.toggle('is-open', opening);

	const end = opening ? item.offsetHeight : summary.offsetHeight + parseFloat(getComputedStyle(item).borderTopWidth);

	const animation = item.animate([{ height: `${start}px` }, { height: `${end}px` }], {
		duration: DURATION,
		easing: 'cubic-bezier(0.22, 0.61, 0.36, 1)',
	});

	item.style.overflow = 'hidden';
	animation.onfinish = () => {
		item.style.overflow = '';

		if (!opening) {
			item.open = false;
		}
	};
}

function bind(list: HTMLElement): void {
	list.querySelectorAll<HTMLDetailsElement>('details').forEach((item) => {
		const summary = item.querySelector<HTMLElement>('summary');

		if (!summary) {
			return;
		}

		item.classList.toggle('is-open', item.open);

		summary.addEventListener('click', (event) => {
			if (reduced.matches) {
				item.classList.toggle('is-open', !item.open);
				return;
			}

			event.preventDefault();
			toggle(item, summary);
		});
	});
}

export default function initFaq(): void {
	document.querySelectorAll<HTMLElement>('[data-armada-faq]').forEach(bind);
}
